/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.19.0
 */

import { TTableColumnCell } from '../../../types';
import TableCell from '../TableCell';
import DateCell from './DateCell';
import { TTableCellDate } from './types';

function TableCellDate<D extends object>(cell: TTableCellDate<D>): Pick<TTableColumnCell<D>, 'Cell'> {
    return {
        Cell: (props) =>
            TableCell(props)({
                render: ({ row }) => {
                    const { date, format, enableSubtitle } = cell(row);
                    return <DateCell date={date} enableSubtitle={enableSubtitle} format={format} />;
                },
            }),
    };
}

export default TableCellDate;
